<template>
  <div class="contents contents--pt">
    <section class="Form _min-h">
      <div class="inner">
        <div class="Form--pt">
          <p class="Form__tx">
            確認用のメールを送付いたしました。<br>
            メールに記載された確認用URLをクリックすると、<br class="_dsp-none--sp">
            変更お手続き完了となります。
          </p>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import store from '@/store'
import { redirect } from '@/helpers'

export default {
  name: 'SendMail',
  methods: {
    redirectToLogin() {
      store.dispatch('user/logout')
      redirect('/')
    }
  }
}
</script>
